/**
 * @param installationId
 * @param emcId from dto device-links emc.id (or parsed emc.deviceId)
 */
export const scanForHeatpumpWs = (installationId: number, emcId: string, token: string): WebSocket => {
  return new WebSocket(
    `${process.env.REACT_APP_INSTALLATIONS_ENDPOINT}/installations/${installationId}/device-links/${emcId}/scan/hp-with-isg/ws?authorization=${token}`
  )
}
